import { Navigate } from "react-router-dom";

export default function NavigateHome() {
  return <Navigate to="/404" />;
}
